import { render } from "./Overlay.vue?vue&type=template&id=6479c9f1"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__